import { FC } from 'react';
import { Helmet } from '@edikk-edikk/helmet';
import { useBaseContext } from '#base/hooks';

const Noindex: FC = () => {
  const { noindex } = useBaseContext();

  if (!noindex) {
    return null;
  }

  return (
    <Helmet>
      <meta id="robots-meta-tag" name="robots" content="noindex,follow" />
    </Helmet>
  );
};

export { Noindex };
